export default function BottomCTA() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 max-w-2xl">
            Pronto para Começar a Comprar?
          </h2>
          <p className="text-foreground-600 text-base md:text-lg mt-4 max-w-xl">
            Acede agora à planilha CSSBuy mais completa em português. Links
            atualizados, vendedores confiáveis e os melhores preços.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 bg-accent-500 text-white font-bold px-10 py-4 rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all duration-200 inline-flex items-center gap-2"
          >
            Aceder à Planilha Agora
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-16 flex justify-center">
          <img
            src="https://readdy.ai/api/search-image?query=Panoramic%20horizontal%20banner%20of%20assorted%20fashion%20items%20on%20pristine%20white%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20warm%20neutral%20beige%20and%20cream%20palette%2C%20clean%20ecommerce%20catalog%20layout&width=1400&height=300&seq=cta-bottom-v2&orientation=landscape"
            alt="Produtos CSSBuy"
            title="Produtos CSSBuy Spreadsheet"
            className="w-full max-w-5xl h-auto object-cover rounded-3xl"
          />
        </div>
      </div>
    </section>
  );
}